export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' }
  },
  {
    title: that.$l('form_label_salesChannel') || '销售渠道',
    field: 'salesChannel',
    minWidth: 140,
    align: 'center',
  },
  {
    title: that.$l('form_label_orderNo') || '订单编号',
    field: 'orderNo',
    minWidth: 140,
    align: 'center',
  },
  {
    title: that.$l('form_label_customerOrderNo') || '客户订单编号',
    field: 'customerOrderNo',
    minWidth: 140,
    align: 'center',
  },
  {
    title: that.$l('form_label_orderDate') || '下单时间',
    field: 'v_orderDate',
    minWidth: 170,
    align: 'center',
  },
  {
    title: that.$l('form_label_created') || '系统订单',
    field: 'v_created',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    slots: { default: 'created' },
  },
  {
    title: that.$l('form_label_shipped') || '订单发货',
    field: 'v_shipped',
    minWidth: 100,
    align: 'center',
    slots: { default: 'shipped' },
  },
  {
    title: that.$l('INDEX.table_label_created_date') || '创建人',
    field: 'v_createTime',
    headerAlign: 'center',
    align: 'center',
    minWidth: 170,
  },
  {
    title: that.$l('INDEX.table_label_modification_time') || '修改人',
    field: 'v_modifyTime',
    headerAlign: 'center',
    align: 'center',
    minWidth: 170,
  }
]
